export const EShapeActionValueTransformResizeType = wcardinal.ui.EShapeActionValueTransformResizeType;